import ProductTinder from './ProductTinder';

const index = {
  ProductTinder,
};

export default index;

